<template>
  <div :class="classes">
    <h4 class="package-option__header">{{ packageOption.RetailName }}</h4>
    <div class="package-option__option-products">
      <option-product
        v-for="(optionProduct, opIndex) in packageOption.OptionProducts"
        :key="opIndex"
        :option-product-index="opIndex"
        :option-product="optionProduct"
        :package-option-index="packageOptionIndex"
        :package-option="packageOption"
      />
    </div>
    <package-option-preview-modal
      v-if="hasPreviewModal"
      :package-option="packageOption"
      class="package-option__preview-modal-wrapper"
    />
  </div>
</template>

<script>
import OptionProduct from './OptionProduct/OptionProduct'
import PackageOptionPreviewModal from '@Shared/components/catalog/PackageOptionPreviewModal.vue'
import { findIndex } from 'lodash'

export default {
  name: 'PackageOption',
  components: {
    OptionProduct,
    PackageOptionPreviewModal
  },
  props: {
    packageOption: { type: Object, default: null, required: true },
    packageOptionIndex: { type: Number, default: null, required: true }
  },
  computed: {
    classes () {
      return {
        'package-option': true,
        'package-option--with-preview-modal': this.hasPreviewModal
      }
    },
    selectedOptionProductsByCatalogPackageOption () {
      return this.$store.getters.getSelectedOptionProductsByCatalogPackageOption(this.packageOption.CatalogPackageOptionID)
    },
    singleSelectionIsRequired () {
      return this.packageOption.Min === 1 && this.packageOption.Max === 1
    },
    hasPreviewModal () {
      return this.packageOption.CmsOptionGroupDetail !== null
    }
  },
  watch: {
    selectedOptionProductsByCatalogPackageOption (v) {
      if (v.length === 0 && this.singleSelectionIsRequired) {
        this.selectFirstAvailableOptionProduct()
      }
    }
  },
  mounted () {
    const configuredOptionProductId = this.$store.getters.getConfiguredValue(`OptionProductIDForPackageOption_${this.packageOption.CatalogPackageOptionID}`)

    if (this.singleSelectionIsRequired && configuredOptionProductId === null) {
      this.selectFirstAvailableOptionProduct()
    }
  },
  methods: {
    selectFirstAvailableOptionProduct () {
      const firstAvailableOptionProductIndex = findIndex(this.packageOption.OptionProducts, (op) => {
        return this.$store.state.optionProducts.prohibitedProducts.indexOf(op.ClassName) === -1
      })

      const firstAvailableOptionProduct = this.packageOption.OptionProducts[firstAvailableOptionProductIndex]
      const globalZOrder = this.packageOptionIndex + firstAvailableOptionProductIndex

      this.$store.dispatch('addOneSelectedOptionProductPerCatalogPackageOption', { optionProduct: firstAvailableOptionProduct, catalogPackageOptionId: this.packageOption.CatalogPackageOptionID, zOrder: globalZOrder })
    }
  }
}
</script>

<style lang="scss" scoped>
.package-option {
  margin-bottom: 10px;

  &__header {
    background-color: #eee;
    font-size: 30px;
    font-weight: 600;
    margin-bottom: 20px;
    padding: 10px 0;
    text-align: center;
  }

  &__preview-modal-wrapper {
    margin: 5px 0 20px 0;
  }

  &--with-preview-modal {
    margin-bottom: 0;
  }
}
</style>



// WEBPACK FOOTER //
// WebResources/vue/letter-jackets/catalog-details/components/PackageOptions/PackageOption.vue